export default "__VITE_ASSET__Cpi5x4Ig__"